import { externalFormSchema, form360Schema, standardFormSchema } from "../../../../../../components/FormSelectionCard";

import type { AddFormsStepData, FormType } from "./types";

export type ValidationFailure = { kind: "no-template" } | { kind: "invalid-form"; formType: FormType; localId: string };

export type ValidationResult = { valid: true } | { valid: false; failures: ValidationFailure[] };

const SCHEMA_BY_TYPE = {
	standard: standardFormSchema,
	"360": form360Schema,
	external: externalFormSchema,
} as const;

export const validateAddForms = (data: AddFormsStepData | undefined): ValidationResult => {
	const stepData: AddFormsStepData = data ?? {
		selectedTemplate: null,
		forms: { standard: [], "360": [], external: [] },
	};

	const failures: ValidationFailure[] = [];

	if (!stepData.selectedTemplate) {
		failures.push({ kind: "no-template" });
	}

	for (const formType of ["standard", "360", "external"] as const) {
		for (const form of stepData.forms[formType]) {
			const schema = SCHEMA_BY_TYPE[formType];
			const result = schema.safeParse(form.data);
			if (!result.success) {
				failures.push({ kind: "invalid-form", formType, localId: form.localId });
			}
		}
	}

	return failures.length === 0 ? { valid: true } : { valid: false, failures };
};
